"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.truncate = void 0;
/**
 * Truncate a string to end with ellipsis
 * @param value String to be truncated
 * @param length Final length of the string (endingCharacters inclusive)
 * @example truncate("Hello World!", 6); // Hello…
 */
const truncate = (value, length = 100, endingCharacter = '') => value.length + endingCharacter.length > length
    ? `${value.slice(0, length - endingCharacter.length)}${endingCharacter}`
    : value;
exports.truncate = truncate;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHJ1bmNhdGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdXRpbHMvdHJ1bmNhdGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUE7Ozs7O0dBS0c7QUFDSSxNQUFNLFFBQVEsR0FBRyxDQUFDLEtBQWEsRUFBRSxTQUFpQixHQUFHLEVBQUUsa0JBQTBCLEVBQUUsRUFBVSxFQUFFLENBQ3BHLEtBQUssQ0FBQyxNQUFNLEdBQUcsZUFBZSxDQUFDLE1BQU0sR0FBRyxNQUFNO0lBQzVDLENBQUMsQ0FBQyxHQUFHLEtBQUssQ0FBQyxLQUFLLENBQUMsQ0FBQyxFQUFFLE1BQU0sR0FBRyxlQUFlLENBQUMsTUFBTSxDQUFDLEdBQUcsZUFBZSxFQUFFO0lBQ3hFLENBQUMsQ0FBQyxLQUFLLENBQUM7QUFIQyxRQUFBLFFBQVEsWUFHVCJ9